import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const getWpContent = (url) => {
  return new Promise((resolve, reject) => {
    axios.get(url)
    .then(response => {
      resolve(response.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

export default new Vuex.Store({
  state: {
    config: {
      baseurl: 'https://especiales.latercera.com/transition',
      title: 'Transition',
      description: 'Chile is just beginning to understand and accept Transgender people. What is it like to transition and live as a transgender in our country?',
      hashtag: '#transicionlt',
      brandtitle: 'Presented by Wom',
      reporttitle: 'Featured Story: Transition by La Tercera',
      img: '/content/share.jpg',
      slug: '/',
      modal: false,
      gallery: false,
      moving: false,
      menu: false,
      lab: {
        logo: 'assets/images/logos/laboratorio-de-contenidos-de-marca.svg',
        title: 'Laboratorio de Contenidos',
        url: 'http://www.laboratoriodecontenidos.cl',
        height: '30'
      },
      brand: {
        logo: 'assets/images/logos-white/quepasa.svg',
        title: 'Qué Pasa',
        url: {
          name: "home"
        },
        height: '40'
      },
      sponsor: {
        logo: 'assets/images/logo-wom.svg',
        title: 'wom',
        url: {
          name: "home"
        },
        height: '50'
      },
      home: {
        video: '<iframe width="560" height="315" src="https://www.youtube.com/embed/fgUqmUVdQVc?controls=0&autoplay=1&enablejsapi=1&modestbranding=1&playsinline=1&cc_load_policy=1&cc_lang_pref=en" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
      }
    },
    podcast: {
      opened: false,
      running: false,
      url: '',
      title: '',
      artist: 'Radio Zero'
    },
    credits:[
      {
        'role': 'Creation and coordination of the project, research, scripts and texts',
        'persons': [
          'Tania Opazo'
        ]
      },
      {
        'role': 'Filmmaking',
        'persons': [
          'Catalina Jaque',
          'Alex Utreras'
        ],
      },
      {
        'role': 'Photos',
        'persons': [
          'Juan Farías',
          'Rudy Muñoz',
          'Patricio Fuentes',
          'Reinaldo Ubilla'
        ],
      },
      {
        'role': 'Infographics',
        'persons': [
          'Hilda Oliva',
          'Álvaro Stuardo',
          'Rodrigo Valenzuela',
          'Heglar Fleming'
        ],
      },
      {
        'role': 'Podcasts',
        'persons': [
          'Tania Opazo',
          'Sergio Fortuño (Radio Zero)',
          'Tania Selaive (Radio Zero)'
        ]
      },
      {
        'role': 'Web Development',
        'persons': [
          'Álex Acuña Viera'
        ]
      },
      {
        'role': 'Design',
        'persons': [
          'Felipe de la Fuente',
          'Sandro Baeza'
        ],
      },
      {
        'role': 'English Translation',
        'persons': [
          'Pablo Siredey',
          'Carola Inostroza'
        ],
      }
    ],
    sections: [
      {
        title: 'My Transition',
        slug: '/my-transition',
        undertitle: '',
        downtitle: 'What is living as a transgender in Chile like? Six people share their transition stories and experiences.',
        innertitle: 'Chile is just beginning to understand and accept Transgender people. What is it like to transition and live as a transgender in our country? A trans man, a trans woman, a non-binary trans person, a trans teenager, a trans child and an elder trans woman share their stories in this feature, opening a window to the reality of this community.',
        img: 'content/mi-transicion.jpg',
        shareimg: '/content/sharers/share-ambar.jpg',
        inhome: false,
        looper: true
      },
      {
        title: 'Trans Science',
        slug: '/trans-science',
        undertitle: '',
        downtitle: 'A space for education and reflection, from the biological and the social sciences, to the phenomenon of transgenderism.',
        img: 'content/ciencia-trans.jpg',
        shareimg: '/content/sharers/share-ciencia-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/864',
        inhome: true
      },
      {
        title: 'Trans Health',
        slug: '/trans-health',
        undertitle: '',
        downtitle: 'The debate over pathologization, the medical problems transgender people face and treatments available.',
        img: 'content/salud-trans.jpg',
        shareimg: '/content/sharers/share-salud-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/869',
        inhome: true
      },
      {
        title: 'Trans Chile',
        slug: '/trans-chile',
        undertitle: '',
        downtitle: 'Social movements, achievements and pending battles. We review the past, present and future of the trans community in Chile.',
        img: 'content/chile-trans.jpg',
        shareimg: '/content/sharers/share-chile-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/863',
        inhome: true
      },
      {
        title: 'Trans Childhood',
        slug: '/trans-childhood',
        undertitle: '',
        downtitle: 'The children who stressed the debate and put transgenderism in the public eye. A generation that is writing a new way of being trans.',
        img: 'content/infancia-trans.jpg',
        shareimg: '/content/sharers/share-infancia-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/867',
        inhome: true
      },
      {
        title: 'Trans Progress',
        slug: '/trans-progress',
        undertitle: '',
        downtitle: 'Developments in the rights of transgender people in our country until the recently passed Gender Identity Act (GIA)',
        img: 'content/avance-trans.jpg',
        shareimg: '/content/sharers/share-avance-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/862',
        inhome: true
      },
      {
        title: 'Lenguaje Inclusivo',
        slug: '/la-lengua-muy-bien-gracias',
        undertitle: '',
        downtitle: '',
        img: 'content/avance-trans.jpg',
        shareimg: '/content/sharers/share-avance-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/868',
        inhome: false
      },
      {
        title: 'Activista',
        slug: '/activista',
        undertitle: '',
        downtitle: '',
        img: 'content/avance-trans.jpg',
        shareimg: '/content/sharers/share-avance-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/861',
        inhome: false
      },
      {
        title: 'Derecho a las Identidades',
        slug: '/el-derecho-a-las-identidades-sexuales',
        undertitle: '',
        downtitle: '',
        img: 'content/avance-trans.jpg',
        shareimg: '/content/sharers/share-avance-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/865',
        inhome: false
      },
      {
        title: 'Experiencias Trans',
        slug: '/trans-experiences',
        undertitle: '',
        downtitle: '',
        img: 'content/avance-trans.jpg',
        shareimg: '/content/sharers/share-avance-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/866',
        inhome: false
      },
      {
        title: 'Health podcast transcription',
        slug: '/health-podcast',
        undertitle: '',
        downtitle: '',
        img: 'content/salud-trans.jpg',
        shareimg: '/content/sharers/share-salud-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/1167',
        inhome: false
      },
      {
        title: 'GIA podcast transcription',
        slug: '/gia-podcast',
        undertitle: '',
        downtitle: '',
        img: 'content/avance-trans.jpg',
        shareimg: '/content/sharers/share-avance-trans.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/pages/1170',
        inhome: false
      },
    ],
    articles: [
      {
        title: 'Martín',
        undertitle: 'With 30 years, Martín is almost nine months with hormonal treatment to fulfill his sex transition. Despite certain resistance in his family, he\'s happy: He feels that finally has started to live.',
        credits: '<p>By: <strong>Tania Opazo</strong></p><p>Photos: <strong>Juan Farías</strong></p><p>Filmmaking: <strong>Catalina Jaque</strong></p>',
        img: 'content/mi-transicion/martin.jpg',
        imgsmall: 'content/mi-transicion/martin-small.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/posts/844',
        slug: 'martin',
        share: {
          title: 'Martín',
          description: 'With 30 years, Martín is almost nine months with hormonal treatment to fulfill his sex transition. Despite certain resistance in his family, he\'s happy: He feels that finally has started to live.',
          img: '/content/sharers/share-martin.jpg'
        }
      },
      {
        title: 'Ámbar',
        undertitle: 'Ámbar always dreamed since she was a little child with carrying dresses, makeup, and high heels. She tried to repress it, being the "macho" that all expected, until one day she accepts that she feels, and is, a woman.',
        credits: '<p>By: <strong>Tania Opazo</strong></p><p>Photos: <strong>Juan Farías</strong></p><p>Filmmaking: <strong>Catalina Jaque</strong></p>',
        img: 'content/mi-transicion/ambar.jpg',
        imgsmall: 'content/mi-transicion/ambar-small.jpg',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/posts/851',
        slug: 'ambar',
        share: {
          title: 'Ámbar',
          description: 'Ámbar always dreamed since she was a little child with carrying dresses, makeup, and high heels. She tried to repress it, being the "macho" that all expected, until one day she accepts that she feels, and is, a woman.',
          img: '/content/sharers/share-ambar.jpg'
        }
      },
      {
        title: 'Francis',
        undertitle: 'It has only 20 years old but Francis has gone a long way to dare to say that he doesn\'t want to be filed as a man or woman. Thanks to his dad and brother support, today he defines himself as non-binary gender.',
        credits: '<p>By: <strong>Tania Opazo</strong></p><p>Photos: <strong>Juan Farías</strong></p><p>Filmmaking: <strong>Catalina Jaque</strong></p>',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/posts/849',
        img: 'content/mi-transicion/fran.jpg',
        imgsmall: 'content/mi-transicion/fran-small.jpg',
        slug: 'francis',
        share: {
          title: 'Francis',
          description: 'It has only 20 years old but Francis has gone a long way to dare to say that he doesn\'t want to be filed as a man or woman. Thanks to his dad and brother support, today he defines himself as non-binary gender.',
          img: '/content/sharers/share-francis.jpg'
        }
      },
      {
        title: 'Ángela',
        undertitle: 'In gentle ways and calm voice, Angela never felt comfortable among the cries and balls of her schoolmates. Today she enjoys wearing skirts and dancing k-pop, like any teenager. Like the girl who always was.',
        credits: '<p>By: <strong>Tania Opazo</strong></p><p>Photos: <strong>Juan Farías</strong></p><p>Filmmaking: <strong>Catalina Jaque, Álex Utreras</strong></p>',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/posts/848',
        img: 'content/mi-transicion/angela.jpg',
        imgsmall: 'content/mi-transicion/angela-small.jpg',
        slug: 'angela',
        share: {
          title: 'Ángela',
          description: 'In gentle ways and calm voice, Angela never felt comfortable among the cries and balls of her schoolmates. Today she enjoys wearing skirts and dancing k-pop, like any teenager. Like the girl who always was.',
          img: '/content/sharers/share-angela.jpg'
        }
      },
      {
        title: 'Alexis',
        undertitle: 'She was barely three years old and Alexis told her mom that she did not want to comb her hair or wear pink clothes. Despite the doubts, his parents supported him. He already has six and naturally explains that he is transgender.',
        credits: '<p>By: <strong>Tania Opazo</strong></p><p>Photos: <strong>Juan Farías</strong></p><p>Filmmaking: <strong>Catalina Jaque, Álex Utreras</strong></p>',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/posts/847',
        img: 'content/mi-transicion/alexis.jpg',
        imgsmall: 'content/mi-transicion/alexis-small.jpg',
        slug: 'alexis',
        share: {
          title: 'Alexis',
          description: 'She was barely three years old and Alexis told her mom that she did not want to comb her hair or wear pink clothes. Despite the doubts, his parents supported him. He already has six and naturally explains that he is transgender.',
          img: '/content/sharers/share-alexis.jpg'
        }
      },
      {
        title: 'Katty',
        undertitle: 'Katty left her house as a child and started living on the street when she was still under the age of majority. He says that he is a survivor of a generation that never heard the word trans and lived through the harshest discrimination.',
        credits: '<p>By: <strong>Tania Opazo</strong></p><p>Photos: <strong>Juan Farías</strong></p><p>Filmmaking: <strong>Catalina Jaque, Álex Utreras</strong></p>',
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/posts/846',
        img: 'content/mi-transicion/katty.jpg',
        imgsmall: 'content/mi-transicion/katty-small.jpg',
        slug: 'katty',
        share: {
          title: 'Katty',
          description: 'Katty left her house as a child and started living on the street when she was still under the age of majority. He says that he is a survivor of a generation that never heard the word trans and lived through the harshest discrimination.',
          img: '/content/sharers/share-katty.jpg'
        }
      },
      {
        title: 'Amparo',
        undertitle: 'As a way to show their support to gender diversity, WOM sponsors this Transition feature and share their integration story with Amparo, who is part of their working team.',
        credits: '<p>By: <strong>Belén Peña L.</strong></p><p>Filmmaking: <strong>Álex Utreras</strong></p>',
        wom: true,
        url: 'https://copesano.acunaviera.com/wp-json/wp/v2/posts/1154',
        img: 'content/mi-transicion/amparo.jpg',
        imgsmall: 'content/mi-transicion/amparo-small.jpg',
        slug: 'amparo',
        share: {
          title: 'Amparo',
          description: 'As a way to show their support to gender diversity, WOM sponsors this Transition special and share their integration story with Amparo, who is part of their working team.',
          img: '/content/sharers/share-amparo.jpg'
        }
      },
    ],
    timeline: [
      {
        year: 1973,
        milestones: [
          {
            text: 'First manifestation of transvestites at Santiago’s Plaza de Armas.',
            img: 'content/1973.jpg',
            url: ''
          },
          {
            text: 'First genital modification surgery performed in Chile.',
            img: '',
            url: 'https://www.latercera.com/tendencias/noticia/la-revolucion-marcia-alejandra/132019/'
          }
        ],
      },
      {
        year: 1974,
        milestones: [
          {
            text: 'First name and sex change registration in Chile under Act 17,344.',
            img: '',
            url: 'https://www.latercera.com/tendencias/noticia/la-revolucion-marcia-alejandra/132019/'
          }
        ]
      },
      {
        year: 1988,
        milestones: [
          {
            text: '‘Las Yeguas del Apocalipsis’ (The Apocalypse Queens), an artistic collective formed by Pedro Lemebel and Francisco Casas, make their first public appearance. The trans and homosexual issue marks the performances made by the duo.',
            url: '',
            img: 'content/1988.jpg',
          }
        ]
      },
      {
        year: 1999,
        milestones: [
          {
            text: 'First March for Diversity.',
            img: 'content/1999.jpg',
            url: ''
          }
        ]
      },
      {
        year: 2011,
        milestones: [
          {
            text: 'Publication of the Vía Clínica of the Ministry of Health, a technical guide that contains criteria for regulating the psychological and physical transition of a trans person.',
            img: '',
            url: 'content/2011-4-via-clinica-minsal.pdf'
          },
          {
            text: 'Circular No. 34 of the Ministry of Health regulates the mandatory use of transgender people’s social name in the clinical record.',
            img: '',
            url: 'content/2011-5-circular-34-21.pdf'
          }
        ]
      },
      {
        year: 2012,
        milestones: [
          {
            text: 'Act 20,609, known as the Zamudio Act, is passed, establishing gender identity as a category suspected of discrimination.',
            img: '',
            url: 'https://www.bcn.cl/leyfacil/recurso/ley-de-no-discriminacion'
          }
        ]
      },
      {
        year: 2013,
        milestones: [
          {
            text: 'A bill recognizing and protecting the right to gender identity is filed to the Senate.',
            img: '',
            url: 'http://www.senado.cl/appsenado/templates/tramitacion/index.php?boletin_ini=8924-07'
          }
        ]
      },
      {
        year: 2014,
        milestones: [
          {
            text: 'Hija de Perra * (Víctor Pérez) passes away, a quick change artist and scenic artist who stood out as a social activist for the rights of women and sexual minorities.',
            img: 'content/2014-6-hija.jpg',
            url: ''
          }
        ]
      },
      {
        year: 2015,
        milestones: [
          {
            text: 'The first Trans Fest, Festival for the De-pathologization of Trans Identities, is held.',
            img: 'content/2015-7-transfest.jpg',
            url: ''
          },
          {
            text: 'Circular 18 of the Ministry of Health instructs to stop unnecessary "normalization" treatments for intersex children, including irreversible genital surgeries, until they are old enough to decide about their bodies.',
            img: '',
            url: 'content/2015-8-circular-18.pdf'
          }
        ]
      },
      {
        year: 2017,
        milestones: [
          {
            text: 'First thematic hearing of the Inter-American Commission on Human Rights on the human rights status of trans people in Chile.',
            img: 'content/2017-9-comision.jpg',
            url: 'https://www.youtube.com/watch?v=CW-O4uPT3vI'
          },
          {
            text: 'The Superintendency of Education’s Circular states that schools must respect the gender identity and expression of trans students.',
            img: '',
            url: 'content/2017-10-mineducacion.pdf'
          },
          {
            text: 'Ministry of Education launches the document: Guidelines for the inclusion of lesbian, gay, bisexual, trans and intersex people',
            img: '',
            url: 'content/2017-11-ministerio.pdf'
          },
          {
            text: 'For the first time, the Supreme Court welcomes a non-discrimination action based on gender identity, the case of Alejandra González, former councilor of Lampa.',
            img: '',
            url: 'http://www2.latercera.com/noticia/corte-suprema-acoge-demanda-discriminacion-concejala-transgenero/'
          },
          {
            text: 'A Labor Inspectorate\'s ruling states that it is the employer\'s duty to respect the self-perceived gender identity and to provide access to the hygienic services corresponding to that identity.',
            img: '',
            url: 'content/2017-11-inspeccion.pdf'
          }
        ]
      },
      {
        year: 2018,
        milestones: [
          {
            text: 'The film A Fantastic Woman wins best foreign film at the Oscars',
            img: 'content/2018-12-mujerfantastica.jpg',
            url: ''
          },
          {
            text: 'For the first time, the Supreme Court gives judgment on a name and sex change registration application, accepting the appeal without the surgery requirement for that matter.',
            img: '',
            url: 'https://www.latercera.com/politica/noticia/suprema-cita-tratados-internacionales-acoger-cambio-sexo-registral-mujer-trans/186549/'
          },
          {
            text: 'Gender Identity Act is approved by Congress.',
            img: 'content/2018-13-aprobacion.jpg',
            url: 'https://www.latercera.com/politica/noticia/camara-diputados-aprueba-ley-identidad-genero-95-votos-favor-46/317686/'
          }
        ]
      }
    ]
  },
  mutations: {
    SET_PODCAST: (state, payload) => {
      state.podcast = {
        opened: true,
        running: true,
        url: payload.url,
        title: payload.title,
        artist: payload.artist || 'Radio Zero'
      }
    },
    CLOSE_PODCAST: (state) => {
      state.podcast.opened = false
    },
    SET_CONTENT: (state, payload) => {
      state.articles[payload.index].content = payload.content;
    },
    SET_SECTION_CONTENT: (state, payload) => {
      state.sections[payload.index].content = payload.content;
    },
    TOGGLE_MODAL: (state) => {
      state.config.modal = !state.config.modal
    },
    TOGGLE_MENU: (state) => {
      state.config.menu = !state.config.menu
    },
    TOGGLE_GALLERY: (state) => {
      state.config.gallery = !state.config.gallery
    },
    SET_MOVING: (state, payload) => {
      state.config.moving = payload
    }
  },
  actions: {
    setPodcast (context, payload) {
      context.commit('SET_PODCAST', payload)
    },
    closePodcast(context) {
      context.commit('CLOSE_PODCAST')
    },
    setMoving (context, payload) {
      context.commit('SET_MOVING', payload)
    },
    toggleModal (context) {
      context.commit('TOGGLE_MODAL')
    },
    toggleMenu(context) {

      context.commit('TOGGLE_MENU')
    },
    toggleGallery(context) {
      context.commit('TOGGLE_GALLERY')
    },
    setContent: async(context, payload) => {
      try {
        const postcontent = await getWpContent(payload.url)
        const articleIndex = context.getters.getArticleIndex(payload.slug)
        return context.commit('SET_CONTENT', {
          content: postcontent.raw,
          index: articleIndex
        })
      } catch (error) {
        throw error
      }
    },
    setSectionContent: async (context, payload) => {
      try {
        const sectioncontent = await getWpContent(payload.url)
        const sectionIndex = context.getters.getSectionIndex(payload.slug)
        return context.commit('SET_SECTION_CONTENT', {
          content: sectioncontent.raw,
          index: sectionIndex
        })
      } catch (error) {
        throw error
      }
    },
  },
  getters: {
    getArticle: (state) => (slug) => {
      const articlearr = state.articles.filter(i => i.slug === slug)
      return articlearr[0]
    },
    getArticleIndex: (state) => (slug) => {
      const articleIndex = state.articles.findIndex(i => i.slug === slug)
      return articleIndex
    },
    getSection: (state) => (slug) => {
      const sectionarr = state.sections.filter(i => i.slug === slug)
      return sectionarr[0]
    },
    getSectionIndex: (state) => (slug) => {
      const sectionIndex = state.sections.findIndex(i => i.slug === slug)
      return sectionIndex
    },
  }
})
